var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TokenManager_refreshTimeout, _TokenManager_currentToken, _TokenManager_expirationTresholdForRefresh;
import { TypedEventEmitter } from './TypedEventEmitter';
import { AuthAction } from './auth.service';
const DEFAULT_EXPIRATION_TRESHOLD_FOR_REFRESH = 5 * 60 * 1000;
export class TokenManager extends TypedEventEmitter {
    constructor(authService, options = {}) {
        super();
        this.authService = authService;
        _TokenManager_refreshTimeout.set(this, void 0);
        _TokenManager_currentToken.set(this, void 0);
        _TokenManager_expirationTresholdForRefresh.set(this, void 0);
        __classPrivateFieldSet(this, _TokenManager_expirationTresholdForRefresh, options.expirationTresholdForRefresh
            ? options.expirationTresholdForRefresh
            : DEFAULT_EXPIRATION_TRESHOLD_FOR_REFRESH, "f");
        this.authService.on('tokenChanged', ({ token }) => {
            this.setToken(token);
        });
        this.authService.on('authStateChanged', ({ action }) => {
            if (action === AuthAction.LOGOUT) {
                this.stopTokenRefresh();
            }
        });
    }
    currentToken() {
        return __classPrivateFieldGet(this, _TokenManager_currentToken, "f");
    }
    decodeToken(token) {
        try {
            const decoded = JSON.parse(window.atob(token.split('.')[1]));
            return decoded;
        }
        catch (error) {
            return undefined;
        }
    }
    setToken(token) {
        const decoded = this.decodeToken(token);
        if (!decoded) {
            this.emit('tokenError', { error: new Error('Invalid token format') });
            return;
        }
        __classPrivateFieldSet(this, _TokenManager_currentToken, token, "f");
        this.scheduleTokenRefresh();
    }
    getTokenExpirationTime(token) {
        try {
            const decoded = JSON.parse(window.atob(token.split('.')[1]));
            if (!decoded || typeof decoded === 'string') {
                throw new Error('Invalid token format');
            }
            return decoded.exp ? decoded.exp * 1000 : 0;
        }
        catch (error) {
            console.error('Error decoding token:', error);
            return 0;
        }
    }
    async performTokenRefresh() {
        try {
            const response = await this.authService.refreshToken();
            if (response.accessToken) {
                this.emit('tokenRefreshed', { token: response.accessToken });
            }
            else {
                this.emit('tokenError', { error: new Error('Token not refreshed') });
            }
        }
        catch (error) {
            this.emit('tokenError', { error: error });
        }
    }
    async scheduleTokenRefresh() {
        if (!__classPrivateFieldGet(this, _TokenManager_currentToken, "f"))
            return;
        if (__classPrivateFieldGet(this, _TokenManager_refreshTimeout, "f")) {
            this.stopTokenRefresh();
        }
        const now = Date.now();
        const expirationTime = this.getTokenExpirationTime(__classPrivateFieldGet(this, _TokenManager_currentToken, "f"));
        const timeToExpiration = expirationTime - now;
        const isTokenExpired = timeToExpiration <= 0;
        if (isTokenExpired) {
            this.emit('tokenExpired', undefined);
            return;
        }
        const nextRefreshTime = timeToExpiration - __classPrivateFieldGet(this, _TokenManager_expirationTresholdForRefresh, "f");
        if (nextRefreshTime <= 0) {
            await this.performTokenRefresh();
            return;
        }
        __classPrivateFieldSet(this, _TokenManager_refreshTimeout, setTimeout(() => this.performTokenRefresh(), nextRefreshTime), "f");
    }
    stopTokenRefresh() {
        if (__classPrivateFieldGet(this, _TokenManager_refreshTimeout, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _TokenManager_refreshTimeout, "f"));
            __classPrivateFieldSet(this, _TokenManager_refreshTimeout, undefined, "f");
        }
    }
    onTokenRefreshed(callback) {
        this.on('tokenRefreshed', callback);
    }
    onTokenExpired(callback) {
        this.on('tokenExpired', callback);
    }
    onTokenError(callback) {
        this.on('tokenError', callback);
    }
}
_TokenManager_refreshTimeout = new WeakMap(), _TokenManager_currentToken = new WeakMap(), _TokenManager_expirationTresholdForRefresh = new WeakMap();
//# sourceMappingURL=token-manager.js.map